export default __webpack_public_path__ + "static/media/contact.d2670dfa.svg";